import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login/Login";
import MainLayout from "./layouts/MainLayout";
import PrivateRoute from "./components/routes/PrivateRoute";
import Dashboard from "./pages/Dashboard/Dashboard";
import BuyerRequirement from "./pages/BuyerRequirement/BuyerRequirementList/buyerRequireList";
import UserList from "./pages/Users/AllUsers/UserList";
import DealCalculator from "./pages/DealCalculator/AdminDealCalculator"
import QueryList from "./pages/Users/Query/QueryList";
import Roles from "./pages/Roles/RoleList/RoleList";
import RolesMenuPermission from "./pages/RoleMenuPermission/AddRoleMenuPermission/AddRoleMenuPermission";
import ProductList from "./pages/Products/ProductList/ProductList";
import AddProduct from "./pages/Products/AddProduct/AddProduct";
import EditProduct from "./pages/Products/EditProduct/EditProduct";
import CategoryList from "./pages/Masters/category/CatgeoryList/CategoryList";
import AddCategory from "./pages/Masters/category/AddCategory/AddCategory";
import EditCategory from "./pages/Masters/category/EditCategory/EditCategory"
import DesiredTypeList from "./pages/Masters/DesiredType/DesiredTypeList/DesiredTypeList";
import AddDesiredType from "./pages/Masters/DesiredType/AddDesiredType/AddDesiredType";
import EditDesiredType from "./pages/Masters/DesiredType/EditDesiredType/EditDesiredType";
import ArticleList from "./pages/Masters/Article Master/ArticleList/ArticleList";
import AddArticle from "./pages/Masters/Article Master/AddArticle/AddAerticle";
import EditArticle from "./pages/Masters/Article Master/EditArticle/EditArticle";
import UomList from "./pages/Masters/UOM/UomList/UomList";
import AddUom from "./pages/Masters/UOM/AddUom/AddUom";
import EditUom from "./pages/Masters/UOM/EditUom/EditUom";
import MetalPurityCaratList from "./pages/Masters/metal_purity_karat/metal_purity_karatList/metal_purity_karatList";
import AddMetalPurityCarat from "./pages/Masters/metal_purity_karat/Addmetal_purity_karat/Addmetal_purity_karat";
import EditMetalPurityCarat from "./pages/Masters/metal_purity_karat/Editmetal_purity_karat/Editmetal_purity_karat";
import AddStock from "./pages/Stock/AddStock/AddStock";
import EditStock from "./pages/Stock/EditStock/EditStock";
import StockList from "./pages/Stock/StockList/StockList";
import AddBrand from "./pages/Brands/AddBrand/AddBrand";
import EditBrand from "./pages/Brands/EditBrand/EditBrand";
import BrandList from "./pages/Brands//BrandList/BrandList";
import FaqList from "./pages/Faq/FaqList/FaqList";
import AddFaq from "./pages/Faq/AddFaq/AddFaq";
import EditFaq from "./pages/Faq/EditFaq/EditFaq";
import ChangePassword from "./pages/Settings/ChangePassword/ChangePassword";
import BannerList from "./pages/Banner/BannerList/BannerList";
import AddBanner from "./pages/Banner/AddBanner/AddBanner";
import EditBanner from "./pages/Banner/EditBanner/EditBanner";
import RoleList from "./pages/Roles/RoleList/RoleList";
import AddRole from "./pages/Roles/AddRole/AddRole";
import EditRole from "./pages/Roles/EditRole/EditRole";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import EmployeeList from "./pages/Masters/Employee Master/EmployeeList/EmployeeList";
import OrderList from "./pages/OrderList/OrderList";
import CancelledOrders from "./pages/OrderList/cancelledorder"
import DiscountList from "./pages/Discount/List/DiscountList";
import InventoryList from "./pages/Masters/Inventory/InventoryList"
import AddDiscount from "./pages/Discount/Add/AddDiscount";
import EditDiscount from "./pages/Discount/Edit/EditDiscount";
import BankPage from "./pages/Masters/Bank Master/BankList";
import GetInvoice from "./pages/Invoices/GetInvoice";
import TermsPage from "./pages/TermCondition/termcondition"; // ✅ adjust path if needed
import AdminNotifications from "./notification/notification";


const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  // ✅ Check auth on load
  useEffect(() => {
    const auth = localStorage.getItem("isAuthenticated");
    if (auth === "true") setIsAuthenticated(true);
  }, []);

  // ✅ Check environment variables
  useEffect(() => {
    // console.log("✅ Admin Panel Running on PORT:", process.env.PORT);
    // console.log("✅ Backend API URL:", process.env.REACT_APP_API_URL);
  }, []);





  return (
    <Router>
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />

          {/* Login */}
          <Route
            path="/login"
            element={
              isAuthenticated ? (
                <Navigate to="/Dashboard" replace />) : (
                <Login setIsAuthenticated={setIsAuthenticated} />
              )
            }
          />

          {/* Dashboard */}
          <Route
            path="/Dashboard"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Dashboard" >
                  <Dashboard />
                </MainLayout>
              </PrivateRoute>
            }
          />

          {/* Users List */}
          <Route
            path="/allusers/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Users">
                  <UserList />
                </MainLayout>
              </PrivateRoute>
            }
          />
          {/* Active Users List */}
          {/* <Route
            path="/activeusers/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Active Users">
                  <ActiveUsersList />
                </MainLayout>
              </PrivateRoute>
            }
          /> */}
          {/* Query List */}
          <Route
            path="/query/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Query">
                  <QueryList />
                </MainLayout>
              </PrivateRoute>
            }
          />

          {/* Roles */}
          <Route
            path="/users/roles"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Roles">
                  <Roles />
                </MainLayout>
              </PrivateRoute>
            }
          />


          {/* Roles */}
          <Route
            path="/users/rolesMenuPermission"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Role Menu Permission">
                  <RolesMenuPermission />
                </MainLayout>
              </PrivateRoute>
            }
          />

          {/* Products */}
          <Route
            path="/product/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Product">
                  <ProductList />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/add/product"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Add Product">
                  <AddProduct />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/edit/product/:id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Edit Product">
                  <EditProduct />
                </MainLayout>
              </PrivateRoute>
            }
          />

          {/* Category */}
          <Route
            path="/category/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Category">
                  <CategoryList />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/add/category"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Add category">
                  <AddCategory />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/edit/category/:id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Edit Category" >
                  <EditCategory />
                </MainLayout>
              </PrivateRoute>
            }
          />


          {/* Category */}
          <Route
            path="/deal-calculator"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Deal Calculator">
                  <DealCalculator />
                </MainLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/metal-type-purity/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Metal Purity">
                  <MetalPurityCaratList />
                </MainLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/add/metal-purity-carat"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Add Metal purity">
                  <AddMetalPurityCarat />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/edit/metal-purity-carat/:id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Edit Metal purity" >
                  <EditMetalPurityCarat />
                </MainLayout>
              </PrivateRoute>
            }
          />


          {/* Dashboard */}
          <Route
            path="/buyerRequirement/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Buyers Requirement" >
                  <BuyerRequirement />
                </MainLayout>
              </PrivateRoute>
            }
          />

          {/* Desired Type */}
          <Route
            path="/desired-type/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Metal Type">
                  <DesiredTypeList />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/add/desired-type"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Add Metal Type">
                  <AddDesiredType />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/edit/desired-type/:id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Edit Metal Type" >
                  <EditDesiredType />
                </MainLayout>
              </PrivateRoute>
            }
          />


          {/* UOM */}
          <Route
            path="/bank-master"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Bank Details">
                  <BankPage />
                </MainLayout>
              </PrivateRoute>
            }
          />


          
          {/* UOM */}
          <Route
            path="/notification"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
              
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Notification">
                  <AdminNotifications />
                </MainLayout>
              </PrivateRoute>
            }
          />

          {/* UOM */}
          <Route
            path="/uom/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
              
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Uom">
                  <UomList />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/add/uom"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Add Uom">
                  <AddUom />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/edit/uom/:id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Edit Uom" >
                  <EditUom />
                </MainLayout>
              </PrivateRoute>
            }
          />
          {/* Article */}
          <Route
            path="/article/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Article">
                  <ArticleList />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/add/article"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Add Article">
                  <AddArticle />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/edit/article/:id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Edit Article" >
                  <EditArticle />
                </MainLayout>
              </PrivateRoute>
            }
          />
          {/* Stock */}
          <Route
            path="/inventory/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Stock">
                  <StockList />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/add/stock"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Add Stock">
                  <AddStock />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/edit/stock/:stock_id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Edit Stock" >
                  <EditStock />
                </MainLayout>
              </PrivateRoute>
            }
          />

          {/* Brand */}
          <Route
            path="/brand/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Brand">
                  <BrandList />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/add/brand"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Add Brand">
                  <AddBrand />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/edit/brand/:id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Edit Brand" >
                  <EditBrand />
                </MainLayout>
              </PrivateRoute>
            }
          />

          {/* Faq */}
          <Route
            path="/faq/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Faq">
                  <FaqList />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/add/faq"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Add Faq">
                  <AddFaq />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/edit/faq/:faq_id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Edit Faq" >
                  <EditFaq />
                </MainLayout>
              </PrivateRoute>
            }
          />

          {/* <Route
            path="/review/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Review">
                  <ReviewList />
                </MainLayout>
              </PrivateRoute>
            }
          /> */}

          {/* Banner */}
          <Route
            path="/banner/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Banner">
                  <BannerList />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/add/banner"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Add Banner">
                  <AddBanner />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/edit/banner/:banner_id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Edit Banner" >
                  <EditBanner />
                </MainLayout>
              </PrivateRoute>
            }
          />


          {/* Employee Master */}
          <Route
            path="/employee-list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Employee List">
                  <EmployeeList />
                </MainLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/order-list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Order List">
                  <OrderList />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/order-list/cancelled"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Cancelled Order">
                  <CancelledOrders />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/Inventory-list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="InventoryList">
                  <InventoryList />
                </MainLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/discount/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Discount List">
                  <DiscountList />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/discount/add"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Add Discount">
                  <AddDiscount />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/discount/edit/:id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Edit Discount">
                  <EditDiscount />
                </MainLayout>
              </PrivateRoute>
            }
          />

          {/* Role */}
          <Route
            path="/role/list"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="All Role">
                  <RoleList />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/add/role"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Add Role">
                  <AddRole />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/edit/role/:role_id"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Edit Role" >
                  <EditRole />
                </MainLayout>
              </PrivateRoute>
            }
          />
       

          <Route
            path="/setting/changepassword"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Change Password">
                  <ChangePassword />
                </MainLayout>
              </PrivateRoute>
            }
          />

          <Route
            path="/invoice"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout collapsed={collapsed} setCollapsed={setCollapsed} setIsAuthenticated={setIsAuthenticated} pageTitle="Get Invoices" >
                  <GetInvoice />
                </MainLayout>
              </PrivateRoute>
            }
          />
          <Route
            path="/termAndCondition"
            element={
              <PrivateRoute isAuthenticated={isAuthenticated}>
                <MainLayout
                  collapsed={collapsed}
                  setCollapsed={setCollapsed}
                  setIsAuthenticated={setIsAuthenticated}
                  pageTitle="Terms & Conditions"
                >
                  <TermsPage />
                </MainLayout>
              </PrivateRoute>
            }
          />

          {/* Fallback */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
        <ToastContainer
          position="top-right"
          autoClose={3000}
          newestOnTop
          closeOnClick
          pauseOnHover
          theme="light"
        />

        {/* ✅ Yeh div Routes ke bahar hona chahiye */}
        {/* <div style={{ textAlign: "center", padding: "20px", marginTop: "auto" }}>
          <h2>Admin Panel</h2>
          <p>Backend API URL: {process.env.REACT_APP_API_URL}</p>
        </div> */}
      </div>
    </Router>
  );
};

export default App;
